import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/migration.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "migrating-to-aepanalytics-reference"
    }}>{`Migrating to AEPAnalytics reference`}</h1>
    <p>{`This document is a reference comparison of AEPAnalytics (3.x) APIs against their equivalent ACPAnalytics (2.x) APIs.`}</p>
    <p>{`The AEPAnalytics extension is implemented purely in Swift and is compatible with the AEPCore Swift SDK. To ensure a smooth transition from the ACPAnalytics SDK, there are no major changes on the API names or definition. For more details, follow the migration guide below for your Swift or Objective-C mobile application. If explanation beyond showing API differences is necessary, it will be captured as an info hint within that API's section.`}</p>
    <h2 {...{
      "id": "aepanalytics-classes"
    }}>{`AEPAnalytics classes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP 3.x (Swift)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP 3.x (Objective-C)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ACP 2.x (Objective-C)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Primary Class`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Analytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`AEPMobileAnalytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ACPAnalytics`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "aepanalytics-apis"
    }}>{`AEPAnalytics APIs`}</h2>
    <h3 {...{
      "id": "clearqueue"
    }}>{`clearQueue`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=clear-queue" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=clear-queue" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=clear-queue" mdxType="Tabs" />
    <h3 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=extension-version" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=extension-version" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=extension-version" mdxType="Tabs" />
    <h3 {...{
      "id": "getqueuesize"
    }}>{`getQueueSize`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=get-queue-size" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=get-queue-size" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=get-queue-size" mdxType="Tabs" />
    <h3 {...{
      "id": "gettrackingidentifier"
    }}>{`getTrackingIdentifier`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=get-tracking-identifier" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=get-tracking-identifier" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=get-tracking-identifier" mdxType="Tabs" />
    <h3 {...{
      "id": "getvisitoridentifier"
    }}>{`getVisitorIdentifier`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=get-visitor-identifier" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=get-visitor-identifier" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=get-visitor-identifier" mdxType="Tabs" />
    <h3 {...{
      "id": "sendqueuedhits"
    }}>{`sendQueuedHits`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=send-queued-hits" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=send-queued-hits" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=send-queued-hits" mdxType="Tabs" />
    <h3 {...{
      "id": "setvisitoridentifier"
    }}>{`setVisitorIdentifier`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=set-visitor-identifier" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=set-visitor-identifier" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=set-visitor-identifier" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      